/**
 * Convert DD-MM-YYYY to YYYYMMDD
 * @param date
 * @returns
 */
export const convertDateDateToYmd = (date: string) => {
    return date.split('-').reverse().join('');
};

/**
 * Converts a date string from "DD-MM-YYYY" format to "YYYY-MM-DD" format.
 *
 * @param date - The date string in "DD-MM-YYYY" format.
 * @returns The date string in "YYYY-MM-DD" format.
 */
export const convertDmyToYmd = (date: string) => {
    return date.split('-').reverse().join('-');
};

/**
 * Check the date string is DD-MM-YYYY
 * @param date
 * @returns
 */
export const isDanishDateFormat = (date: string) => {
    const danishDateRegex = /\d{2}-\d{2}-\d{4}/;
    if (date.match(danishDateRegex)) {
        return true;
    } else {
        return false;
    }
};
